import iso3311a2 from 'iso-3166-1-alpha-2';

export const europeanCountries = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
];

export const embargoedCountries = [
  'RU', //Russia
  'IR', //Iran
  'IQ', //Iraq
  'BY', //Belarus
  'SY', //Syria
  'KP', //North Korea
  'CU', //Cuba
  'SD', //Sudan
];

export function getCode(country) {
  return iso3311a2.getCode(country === 'Taiwan' ? 'Taiwan, Province of China' : country);
}

export function getCountries() {
  return iso3311a2.getCountries().map((option) => {
    if (option === 'Taiwan, Province of China') {
      return 'Taiwan';
    }

    return option;
  });
}

/**
 * Returns the country code for a given country
 * @param {string} country - The country name
 * @returns {string} The country code
 *
 * @example
 * getCountryCode('United States') // US
 */
export function getCountryCode(country) {
  return getCode(country);
}
